import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { DynamicFormField, DynamicFormSection } from 'interfaces/dynamic-form-field.interface';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MultipleDynamicFormComponent } from 'components/multiple-dynamic-form/multiple-dynamic-form.component';
import _get from 'lodash-es/get';
import { PAGES, SubmitFormInfo } from '../../dynamic-details.constants';
import { DynamicFormContentDetails } from '../dynamic-form-content-details/dynamic-form-content-details.component';
import { DynamicForm, DynamicFormValue } from 'components/multiple-dynamic-form/multiple-dynamic-form.interface';
import { SignatureComponent } from 'components/signature/signature.component';

@Component({
  selector: 'cm-multiple-dynamic-form-content',
  templateUrl: './multiple-dynamic-form-content.component.html',
  styleUrls: ['./multiple-dynamic-form-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultipleDynamicFormContentComponent implements AfterViewInit, OnChanges {
  @ViewChild(MultipleDynamicFormComponent) multipleDynamicForm: MultipleDynamicFormComponent;
  @ViewChild(SignatureComponent) signatureComponent: SignatureComponent;
  @Input() previewMode = false;
  @Input() isResetEnabled = false;
  @Input() sections: DynamicFormSection[];
  @Input() dynamicForms: DynamicForm[] = [];
  @Input() templateFormFields: DynamicFormField[] = [];
  @Input() disabled = false;
  @Input() formValues: DynamicFormValue[];
  @Input() modalDetails: DynamicFormContentDetails;
  @Input() signatureLink: string;
  PAGES = PAGES;
  elements: DynamicFormField[] = [];

  @Output() screenChange = new EventEmitter<string>();
  @Output() formSubmit = new EventEmitter<SubmitFormInfo>();

  constructor(private modalService: NgbActiveModal) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formValues) {
      if (_get(this.formValues, 'length')) {
        this.dynamicForms = this.formValues.map((form) => ({
          dynamicFormInstanceId: form.dynamicFormInstanceId,
          fields: this.templateFormFields.map((field) => ({ ...field, value: form.formValue[field.id] })),
        }));
      }
    }
  }

  ngAfterViewInit() {
    if (this.previewMode && this.signatureLink) {
      this.signatureComponent.signature = this.signatureLink;
    }
  }

  dismissModal() {
    this.modalService.dismiss();
  }

  onScreenChange(page) {
    this.screenChange.emit(page);
  }

  onSubmitForm() {
    const formData = this.validateAndGetMultipleFormData();
    if (formData) {
      this.formSubmit.emit({ formData, saveAsDraft: false });
    }
  }

  saveAsDraft() {
    const formData = this.multipleDynamicForm.getFormData();
    this.formSubmit.emit({ formData, saveAsDraft: true });
  }

  validateAndGetMultipleFormData() {
    return this.multipleDynamicForm.validateAndGetFormData();
  }
}
